import { UmbracoTypes } from '~/lib/data-contract';
import { usePopularResults } from '~/services/loop54/hooks';
import { Loop54ProductAttributes } from '~/services/loop54/types';
import { memo } from 'react';
import { CarouselWithItems } from './helpers';
import { AttributeFilterParameter } from '~/lib/data-contract/auto-generated/loop54-api-model';

function M30PopularProductCampaignCarousel({
    facettedCampaigns,
    headline,
    link,
    onlyShowInStock = false,
}: Omit<UmbracoTypes.IM30PopularProductCampaignCarouselModule, 'type'>) {
    const filters: AttributeFilterParameter[] = [];

    const labels =
        facettedCampaigns.indexOf('\n') !== -1
            ? facettedCampaigns.split('\n').map((label: string) => label.trim())
            : [facettedCampaigns];

    const labelsFilters: AttributeFilterParameter[] = [];
    labels.forEach((label) => {
        labelsFilters.push({
            type: 'attribute',
            attributeName: Loop54ProductAttributes.FacettedCampaigns,
            value: label,
        });
    });

    if (!!onlyShowInStock) {
        filters.push({
            type: 'attribute',
            attributeName: Loop54ProductAttributes.InStock,
            value: onlyShowInStock,
        });
    }

    const { data } = usePopularResults({ applyFilters: filters, orFilters: labelsFilters });

    return <CarouselWithItems data={data?.results?.items} headline={headline} link={link} />;
}

export default memo(M30PopularProductCampaignCarousel);
